import React, { useState } from 'react'
import DescricaoDoProjetoOuInvestimento from '../StepPreenchimentoDaSolicitacao/DescricaoDoProjetoOuInvestimento'
import MotivadorDoCapexNaoPrevisto from '../StepPreenchimentoDaSolicitacao/MotivadorDoCapexNaoPrevisto'
import Detalhes from '../StepPreenchimentoDaSolicitacao/Detalhes'
import Orcamento from '../StepPreenchimentoDaSolicitacao/Orcamento'
import RecursosParaExecucao from '../StepPreenchimentoDaSolicitacao/RecursosParaExecucao'
import ValidacoesAprovacoes from '../StepPreenchimentoDaSolicitacao/ValidacoesAprovacoes'
import { Visibility } from '@app/components/Visibility'
import { hasPermission } from '@app/helpers/permissions'
import VincularAoProjeto from '../StepVincularAoProjeto/VincularAoProjeto'
import OrcamentoFinanceiro from '../StepPreenchimentoDaSolicitacao/OrcamentoFinanceiro'
import { OrcamentoSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/orcamentoSolicitacao'

const StepFinalizado = () => {

      const [list, setList] = useState<OrcamentoSolicitacaoNaoPrevisto[]>([])
      const [orcamentos, setOrcamentos] = useState<OrcamentoSolicitacaoNaoPrevisto[]>([])
      
    return (
        <div spellCheck={true}>
            <DescricaoDoProjetoOuInvestimento />
            <MotivadorDoCapexNaoPrevisto />
            <Detalhes />
            <Orcamento list={list} setList={setList} orcamentos={orcamentos} setOrcamentos={setOrcamentos} />
            <OrcamentoFinanceiro list={list} setList={setList} orcamentos={orcamentos} setOrcamentos={setOrcamentos} />
            <RecursosParaExecucao />
            <ValidacoesAprovacoes />
            <Visibility visible={hasPermission(['NAO_PREVISTO_ADMINISTRADOR'])} >
                <VincularAoProjeto />
            </Visibility>
        </div>
    )
}

export default StepFinalizado